import React from 'react';
import { Alert as MuiAlert } from '@mui/material';

// Custom Alert component to replace @deere/ux.uxframe-react Alert
export const Alert = ({ children, type = 'info', ...props }) => {
  return (
    <MuiAlert severity={type} {...props}>
      {children}
    </MuiAlert>
  );
};

export default Alert;
